import { render } from "./prestacra.vue?vue&type=template&id=57747610"
import script from "./prestacra.vue?vue&type=script&lang=ts"
export * from "./prestacra.vue?vue&type=script&lang=ts"
script.render = render

export default script